export default __webpack_public_path__ + "static/media/wf-isf-sustainability-trends-for-2024_1164x584.ce6a330b.jpg";